import { formatDatePayload } from "@/core/hooks/use-date-time-hook";
import { LOAI_DINH_MUC } from "@/core/constants/const";
import type {
    PhieuXuatKhoChiTietInput,
    PhieuXuatKhoCreateRequest,
} from "@/types/phieu-xuat-kho";
import { loaiDinhMucToApiParam } from "../constants";
import type {
    IPhieuXuatKhoSuppliesQuantityRow,
    PhieuXuatKhoLoaiPhieu,
} from "../types";

interface BuildCreatePayloadOptions {
  loaiPhieu: PhieuXuatKhoLoaiPhieu;
  idKho: number;
  tenNguoiNhan: string;
  lyDo?: string;
  ngay: Date;
  maTkNo?: string;
  tenTkNo?: string;
  maCtNo?: string;
  quantityRows: IPhieuXuatKhoSuppliesQuantityRow[];
  idBienBan?: number;
  loaiDinhMuc?: LOAI_DINH_MUC;
  soBienBan?: string;
}

function buildChiTietItem(
  row: IPhieuXuatKhoSuppliesQuantityRow,
  loaiPhieu: PhieuXuatKhoLoaiPhieu
): PhieuXuatKhoChiTietInput {
  const zeroThuHoiFields = loaiPhieu === 2;

  const item: PhieuXuatKhoChiTietInput = {
    id_vat_tu: row.id_vat_tu,
    so_luong: Number(row.so_luong_se_lay) || 0,
    don_gia: row.don_gia_trong_kho ?? 0,
    sl_tai_sd: zeroThuHoiFields ? 0 : row.tai_sd ?? 0,
    sl_mat: zeroThuHoiFields ? 0 : row.mat ?? 0,
    sl_phe_lieu: zeroThuHoiFields ? 0 : row.so_luong_phe_lieu ?? 0,
    kg_phe_lieu: zeroThuHoiFields ? 0 : row.quy_doi_kg ?? 0,
  };

  if (row.ghi_chu) {
    item.ghi_chu = row.ghi_chu;
  }

  return item;
}

export function buildPhieuXuatKhoCreatePayload(
  options: BuildCreatePayloadOptions
): PhieuXuatKhoCreateRequest {
  const chiTiet = options.quantityRows
    .filter(({ so_luong_se_lay }) => Number(so_luong_se_lay) > 0)
    .map((row) => buildChiTietItem(row, options.loaiPhieu));

  const phieuXuat: PhieuXuatKhoCreateRequest["phieuXuat"] = {
    loai_phieu: options.loaiPhieu,
    id_kho: options.idKho,
    ten_nguoi_nhan: options.tenNguoiNhan,
    ngay: formatDatePayload(options.ngay),
    ly_do: options.lyDo ?? null,
  };

  if (options.loaiPhieu !== 0) {
    phieuXuat.tk_no = {
      ma_tk: options.maTkNo ?? "",
      ten_tk: options.tenTkNo ?? "",
      ma_ct: options.maCtNo ?? "",
    };
  }

  if (options.loaiPhieu === 0) {
    phieuXuat.id_bien_ban_giai_the = options.idBienBan;
    phieuXuat.loai_dinh_muc = options.loaiDinhMuc
      ? loaiDinhMucToApiParam(options.loaiDinhMuc)
      : undefined;
  }

  if (options.soBienBan) {
    phieuXuat.so_bien_ban = options.soBienBan;
  }

  return { phieuXuat, chiTiet };
}
